import React, { useState } from 'react';
import UISectionWrapper, {
  UISectionHeader,
  UISectionBody,
} from '@/components/shared/UISectionWrapper';
import UISectionTitle from '@/components/shared/UISectionTitle';
import UIIconExtraButton from '@/components/shared/UIIconExtraButton';
import CalendarWidget from '../CalendarWidget';
import TodayStats from '../TodayStats';
import MonthStats from '../MonthStats';
import './TodayCalendarSection.scss';

export interface TodayStatsData {
  payments: number;
  tasks: number;
  arrears: number;
  warnings: number;
  vacancy: number;
  newTenants: number;
}

export interface MonthStatsData {
  units: {
    total: number;
    leased: number;
    vacant: number;
  };
  payments: {
    paid: number;
    arrears: number;
    notSet: number;
  };
}

interface TodayCalendarSectionProps {
  selectedDate?: Date;
  onDateChange?: (date: Date) => void;
  todayStats?: TodayStatsData;
  monthStats?: MonthStatsData;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  className?: string;
}

// Мок-дані
const mockTodayStats: TodayStatsData = {
  payments: 32,
  tasks: 48,
  arrears: 12,
  warnings: 19,
  vacancy: 7,
  newTenants: 12,
};

const mockMonthStats: MonthStatsData = {
  units: { total: 184, leased: 160, vacant: 24 },
  payments: { paid: 64, arrears: 22, notSet: 14 },
};

const mockHandlers = {
  onDateChange: (date: Date) => console.log('Date changed:', date),
  onToggleCollapse: () => console.log('Toggle collapse'),
};

const baseClass = 'TodayCalendarSection';

const TodayCalendarSection: React.FC<TodayCalendarSectionProps> = ({
  selectedDate = new Date(),
  onDateChange = mockHandlers.onDateChange,
  todayStats = mockTodayStats,
  monthStats = mockMonthStats,
  isCollapsed = false,
  onToggleCollapse = mockHandlers.onToggleCollapse,
  className = '',
}) => {
  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return date.toLocaleDateString('en-US', options).replace(',', ',');
  };

  // Створюємо action для хедера з новим компонентом
  const headerAction = (
    <UIIconExtraButton
      icon={isCollapsed ? 'expand' : 'collapse'}
      onClick={onToggleCollapse}
      ariaLabel={isCollapsed ? 'Expand calendar' : 'Collapse calendar'}
    />
  );

  return (
    <UISectionWrapper className={`${baseClass} ${className}`} align="stretch">
      <UISectionHeader>
        <UISectionTitle
          title={`Today: ${formatDate(selectedDate)}`}
          action={headerAction}
          showDivider={true}
        />
      </UISectionHeader>

      {!isCollapsed && (
        <UISectionBody>
          <div className={`${baseClass}__content`}>
            <div className={`${baseClass}__calendar`}>
              <CalendarWidget
                selectedDate={selectedDate}
                onDateChange={onDateChange}
              />
            </div>
            <div className={`${baseClass}__stats`}>
              <TodayStats data={todayStats} />
              <MonthStats data={monthStats} />
            </div>
          </div>
        </UISectionBody>
      )}
    </UISectionWrapper>
  );
};

export default TodayCalendarSection;
